import { CheckEmailRequest, ForgotPasswordRequest } from "@givenwell/marketplace-api";
import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { api, queryClient } from "./utils";

export const meQueryOptions = queryOptions({
  queryKey: ["me"],
  queryFn: async () => {
    const res = await api.auth.getMarketplaceUserInfo();
    import("@/utils/analytics")
      .then(module => {
        module.identifyUser(res.id, res.email, res.given_name + " " + res.family_name);
      })
      .catch(console.error);
    return res;
  },
});
export function useUserId() {
  const { data } = useQuery(meQueryOptions);
  return data?.id || "";
}
export function getUserId() {
  const data = queryClient.getQueryData(meQueryOptions.queryKey);
  return data?.id || "";
}

export function useForgotPasswordMutation() {
  return useMutation({
    mutationFn: async (body: ForgotPasswordRequest) => {
      const result = await api.auth.forgotPassword({ application: "marketplace", requestBody: body });
      return result;
    },
    onError: () => {},
  });
}

export function useCheckEmailMutation() {
  return useMutation({
    mutationFn: async (body: CheckEmailRequest) => {
      const result = await api.auth.checkEmail({ application: "marketplace", requestBody: body });
      return result;
    },
  });
}
